import React from "react";
import "./ContentHeader.css"
const ContentHeader = ({ title }) => {
  return (
    <div className="fixed-header">
      <h5 className="title">{title}</h5>
    </div>
  );
};

export default ContentHeader;
